"use client";

import { Link } from "@tanstack/react-router";

export default function UploadResumeBtn() {
  return (
    <Link
      to="/upload-healthcare-resume"
      className="rounded-lg py-2 text-center text-sm font-medium text-gray-500 focus:outline-none focus:ring-4 focus:ring-blue-300"
      aria-label="Upload Resume"
    >
        Upload Resume
    </Link>
  );
}
